import { useGetOne } from 'react-admin';

export const OPS_USER_QUERY = 'ops-users';

export function useOpsUser() {
  //to-do: implement select when we upgrade to react admin 4.0 and actually use react-query

  return useGetOne(OPS_USER_QUERY, { id: 'current-user' });
}
